<template>
   <div  v-loading.fullscreen.lock="loading">
        <navHeader @login="changeVisible"></navHeader>
        <router-view/>
        <navFooter></navFooter>
        <login v-if="loginVisible" :loginPath="loginPath" :loginVisible.sync="loginVisible" @login="changeVisible"></login>
        <resetPassword v-if="resetVisible" :resetVisible.sync="resetVisible" @reset="changeVisible"></resetPassword>
        <register v-if="registerVisible" :loginPath="loginPath" :registerVisible.sync="registerVisible" @register="changeVisible"></register>
        <wxLogin v-if="wxLoginVisible" :wxLoginVisible.sync="wxLoginVisible"></wxLogin>
        <bindPhone v-if="bindPhoneVisible" :bindPhoneVisible.sync="bindPhoneVisible"></bindPhone>
   </div>
</template>

<script>
import login from './login'
import resetPassword from './resetPassword'
import register from './register'
import navHeader from './navHeader'
import navFooter from './navFooter'
import wxLogin from './wxLogin'
import bindPhone from './bindPhone'
import BindPhone from './bindPhone.vue'
export default {
   data (){
       
       return {
           registerVisible:false,
           loginVisible:false,
           resetVisible:false,
           loginPath:'',
           wxLoginVisible:false,
           bindPhoneVisible:false,
           loading:false,
       }
   },
   components: {  
    navHeader,
    navFooter,
    login,
    resetPassword,
    register,
    wxLogin,
    bindPhone,
    BindPhone
   },
   watch: 
      {
       
   },
   computed: { 
       
   },
   methods: { 
       changeVisible(visible){
           this.loginPath = '';
           this.loginVisible = false;
           this.registerVisible = false;
           this.resetVisible = false;
           if(!visible){
               return
           }
           this[visible] = true;
       },
        getUrlParam(name) {
            //构造一个含有目标参数的正则表达式对象
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            //匹配目标参数
            var r = window.location.search.substr(1).match(reg);
            //返回参数
            if (r != null) {
                return unescape(r[2]);
            } else {
                return null;
            }
        },
        // 更改url
        // 微信登录处理code，然后更改url
        // http://localhost:8080/?id=12345&code=051OtFll2CNgP64kcyol2p3BTO2OtFlu&state=0.9372387909980924#/home
        login(code){
            this.loading = true;
            this.$post('WxLogin',{code:code,client_type:'pc'})
                .then(data => {
                    this.loading = false;
                    this.$message.success('扫码成功！');
                    let pid = this.getUrlParam('id');
                    let newUrl = "/#" + this.$route.path;
                    newUrl = newUrl + (pid ? '?id=' + pid : '')
                    window.history.replaceState('', '', newUrl);
                    if(data.user && data.user.is_bind_phone){
                        if(this.loginPath){
                            this.$router.push(this.loginPath);
                        }else{
                            this.$router.push({path:'/message'});
                        }
                    }else{
                        this.bindPhoneVisible = true;
                    }
                    
                    
                } , error => {
                    this.loading = false;
                    this.$message.error(error);
                });
        }
   },
   created() {
        //微信登录    
        let code = this.getUrlParam('code');
        if(code){
            this.login(code);
        }
        //    判断是否存在未绑定
        // let userMessage = JSON.parse(localStorage.getItem('userMessage') || '{}');
        // if(userMessage.user && !userMessage.user.is_bind_phone){
        //     this.bindPhoneVisible = true;
        // }
        this.$eventBus.$on('login' , path => {
            this.loginVisible = true;
            this.loginPath = path;
        });
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>

</style>



// WEBPACK FOOTER //
// src/components/navMenu.vue